/**
 * Tailwind class bundles for the Dark Mode Lounge (premium) theme.
 * Use with useSiteTheme() — apply on customer-facing screens; admin content
 * also picks up matching rules via siteTheme.css + premiumLounge.css.
 */
export const LOUNGE = {
  canvas: "bg-[#0B0A12]",
  surface:
    "rounded-2xl border border-white/5 bg-[#161426]/70 backdrop-blur-md shadow-lg transition-all duration-300 hover:shadow-[0_0_20px_rgba(168,85,247,0.15)]",
  surfaceStatic: "rounded-2xl border border-white/5 bg-[#161426]/70 backdrop-blur-md",
  heading: "tracking-tight text-white font-bold",
  subtitle: "text-slate-400",
  label: "text-purple-200/60 text-xs uppercase tracking-wider font-semibold",
  accentText: "text-[#E2B659]",
  brandGradient: "bg-gradient-to-r from-[#A855F7] to-[#7C3AED]",
  brandGradientText: "bg-gradient-to-r from-[#A855F7] to-[#7C3AED] bg-clip-text text-transparent",
  pill:
    "rounded-full border border-white/10 bg-white/5 px-4 py-2 text-sm font-semibold text-slate-300 transition-all duration-300 hover:border-purple-500/30 hover:bg-white/10",
  pillActive:
    "rounded-full border border-transparent bg-gradient-to-r from-[#A855F7] to-[#7C3AED] px-4 py-2 text-sm font-semibold text-white shadow-[0_0_20px_rgba(168,85,247,0.25)]",
  cta: "rounded-full bg-gradient-to-r from-[#A855F7] to-[#7C3AED] px-6 py-2.5 text-sm font-semibold text-white shadow-lg transition-transform duration-300 hover:scale-[1.02] active:scale-[0.98]",
  chip: "rounded-full border border-white/10 bg-white/5 px-3 py-1.5 text-sm text-slate-300",
  chipSelected:
    "rounded-full border border-transparent bg-gradient-to-r from-[#A855F7] to-[#7C3AED] px-3 py-1.5 text-sm font-semibold text-white",
  success: "text-emerald-400/90",
  error: "text-rose-400/90",
  kpiCard:
    "rounded-2xl border border-white/5 bg-[#161426]/70 p-4 backdrop-blur-md transition-all duration-300 hover:shadow-[0_0_20px_rgba(168,85,247,0.12)]",
  kpiReference:
    "rounded-2xl border border-purple-500/30 bg-[#161426]/80 p-4 backdrop-blur-md shadow-[0_0_20px_rgba(168,85,247,0.15)]",
};

export function isPremiumLoungeTheme(themeId) {
  return themeId === "premium";
}
